import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface ZhixingItem {
  caseCode: string
  partyCardNum: string
  pname: string
  execCourtName: string
  caseCreateTime: number
  execMoney: string
}

interface TianyanchaZhixinginfoProps {
  data: any
  title: string
  sectionIndex?: string
}

const formatMoney = (money?: string) => {
  if (!money) return '—'
  const num = Number(money)
  if (Number.isNaN(num)) return money
  if (num >= 10000) return `${(num / 10000).toFixed(2)} 万元`
  return `${num.toFixed(2)} 元`
}

const formatDate = (timestamp?: number) => {
  if (!timestamp) return '—'
  return dayjs(timestamp).format('YYYY-MM-DD')
}

const normalizeItems = (items: ZhixingItem[] = []) =>
  items.map((item) => ({
    caseNo: item.caseCode || '—',
    court: item.execCourtName || '—',
    createDate: formatDate(item.caseCreateTime),
    amount: formatMoney(item.execMoney),
    cardNo: item.partyCardNum || '—',
  }))

export default function TianyanchaZhixinginfo({ data, title, sectionIndex }: TianyanchaZhixinginfoProps) {
  let jsonData: any = {}
  try {
    jsonData = JSON.parse(data.tianyancha_zhixinginfo ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const records = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          被执行信息
        </Text>
        <Stack gap="sm" className="mt-3">
          {records.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无被执行人信息
            </Text>
          ) : (
            records.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.caseNo}-${index}`}
                number={index + 1}
                recordType="被执行"
                fields={[
                  { label: '案号', value: item.caseNo },
                  { label: '执行法院', value: item.court },
                  { label: '立案日期', value: item.createDate },
                  { label: '执行标的金额', value: item.amount },
                  { label: '身份证号/组织机构代码', value: item.cardNo, span: 2 },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
